import React from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import AddressSearchMenuItem from '../address-search-menu-item';
import FormSelectField from '../../../../components/form/select-field';
import DeletablePill from '../../../../components/deletable-pill/deletable-pill';
import './delivery-address.css';

const DeliveryAddress = (props) => {
  const {
    deliveryAddressHeadingText,
    deliveryAddressInfoText,
    updateAddressLinkText,
    deliveryAddressValue,
    addressSearch,
    handleAddressSearch,
    handleAddressSelected,
    handleClearSearch,
    handleSuggestedAddressListOnBlur,
    handleUpdateDeliveryAddress,
    showUpdateDeliveryAddressSection,
    suggestedAddressListPlaceHolder,
    addressUpdateCompletedText,
    handleCloseAddressUpdateMessageBox,
  } = props;

  const { addressVerificationInProcess, showAddressUpdateCompletedMessage } = addressSearch;
  return (
    <div className="delivery-details">
      <div className="row">
        <div className="col-md-12 col-sm-12 section-heading pl-sm-0">
          <h2>{deliveryAddressHeadingText}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 col-sm-12 pl-sm-0 section-address">
          {deliveryAddressValue}
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 col-sm-12 pl-sm-0">
          <i className="td-icon icon-help" /><div className="address-info-container">
            <span className="address-info-text">{deliveryAddressInfoText}</span>
            <button type="button" role="link" className="update-address-btn" onClick={handleUpdateDeliveryAddress}>
              {updateAddressLinkText}
            </button>
          </div>
        </div>
      </div>
      {showAddressUpdateCompletedMessage && (
        <div className="row">
          <div className="col-md-12 col-sm-12 pl-sm-0">
            <DeletablePill pillContent={addressUpdateCompletedText} deletePill={handleCloseAddressUpdateMessageBox} />
          </div>
        </div>
      )}
      {showUpdateDeliveryAddressSection && (
        <div className="row">
          <div className="col-md-12  pl-sm-0">
            <AsyncTypeahead
              selectHintOnEnter
              inputProps={{ 'aria-label': 'my-label' }}
              className="text-field"
              {...addressSearch}
              labelKey="address"
              minLength={5}
              onChange={handleAddressSelected}
              useCache={false}
              onSearch={handleAddressSearch}
              disabled={addressSearch.selected.length}
              renderMenuItemChildren={option => (
                <AddressSearchMenuItem
                  key={option.id}
                  addressItem={option}
                />
              )}
            />
            {addressSearch.selected.length > 0 && (
              <button
                type="button"
                className={`button clear-address-btn ${addressVerificationInProcess ? 'loading' : ''}`}
                onClick={handleClearSearch}
              />
            )}
          </div>
          {addressSearch.showSuggestedAddressList && (
            <div className="suggested-address-list-details col-12 pl-sm-0">
              <FormSelectField
                id="suggested-address-list"
                label=""
                disabled={false}
                options={addressSearch.suggestedAddressList}
                value={addressSearch.suggestedAddressSelectedValue}
                onBlur={handleSuggestedAddressListOnBlur}
                placeholder={suggestedAddressListPlaceHolder}
                sendKeyValueOnChange
              />
            </div>
          )}
        </div>
      )}
      <div className="row">
        <div className="col-md-12 col-sm-12 pl-sm-0">
          &nbsp;
        </div>
      </div>

    </div>
  );
};

export default DeliveryAddress;
